import { render, staticRenderFns } from "./CampaignUserTable.vue?vue&type=template&id=4c1f6bc4&scoped=true&"
import script from "./CampaignUserTable.vue?vue&type=script&lang=js&"
export * from "./CampaignUserTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignUserTable.vue?vue&type=style&index=0&id=4c1f6bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f6bc4",
  null
  
)

export default component.exports